/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Share Outline Icon component.
 */
export const SystemShareOutlineIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M16.79 16.5419V19.8036C16.79 20.0798 16.5661 20.3036 16.29 20.3036H4.5C4.22386 20.3036 4 20.0798 4 19.8036V8.01367C4 7.73753 4.22386 7.51367 4.5 7.51367H8.5141' stroke={iconColor} strokeWidth='1.5' />
      <path d='M20.3757 9.127V15.6105C20.3757 15.8867 20.1518 16.1105 19.8757 16.1105H9.01416C8.73802 16.1105 8.51416 15.8867 8.51416 15.6105V4.74902C8.51416 4.47288 8.73802 4.24902 9.01416 4.24902H14.9727' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      <path d='M20.9996 6.76175V3L17.2539 3.19509' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M21 3L15.3813 8.61861' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export default SystemShareOutlineIcon;
